export default {
  props: {
    value: {
      type: [Number, String],
      required: true
    }
  }
}
